import classes from './Ripple.module.css';

const Ripple = () => (
  <div className={classes.ripple}>
    <div>
      <div />
    </div>
  </div>
);

export default Ripple;
